var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgVideo16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.09581C16 1.29712 15.1099 0.820725 14.4453 1.26376L11.8739 2.97805C11.5957 3.16351 11.4286 3.47574 11.4286 3.8101V5.78735C11.4286 6.1217 11.5957 6.43393 11.8739 6.6194L14.4453 8.33368C15.1099 8.77672 16 8.30033 16 7.50163V2.09581Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0.227295C0.447715 0.227295 0 0.675011 0 1.2273V8.37015C0 8.92244 0.447717 9.37015 1 9.37015H9.66667C10.219 9.37015 10.6667 8.92244 10.6667 8.37015V1.22729C10.6667 0.67501 10.219 0.227295 9.66667 0.227295H1ZM4.19026 2.81931L7.61883 4.7988L4.19026 6.77828V2.81931Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideo16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;